import { Typography } from '@/UI/AppTypography/AppTypography';
import { color } from '@/colors';
import { styled } from '@/UI/theme.exports';

export const Plan = styled(Typography)(({ theme }) => ({
  padding: '2px 4px',
  color: `${color.Red2}`,
  backgroundColor: `${color.Pink}`,
  borderRadius: theme.spacing(0.5),
}));
